import React from 'react';
import styled from 'styled-components';

export const Main = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    background: ${(props) => props.backgroundColor}
`;